import { useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';

import Slider from '../../Shared/ReactSlick';

import useSizes from '../../../hooks/sizes';

import withComponentName from '../../../decorators/withComponentName';

// data for Sliders
import * as data from '../../../data/about/dataForSliders';

import Styles from '../styles.module.scss';

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="about-adventure-next"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faChevronRight} />
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="about-adventure-prev"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faChevronLeft} />
    </div>
  );
}

const AboutUsAdventureSection = () => {
  const { width } = useSizes();

  const isDesktop = width < 2800;
  const initialSlide = isDesktop ? 7 : 3;
  const sliderWrapper = useRef();

  useEffect(() => {
    sliderWrapper.current.style.opacity = 1;
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide,
    appendDots: (dots) => (
      <>
        <ul className="about-adventure-slider-dots">{dots}</ul>
      </>
    ),
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className={Styles['about-adventure-section']} ref={sliderWrapper}>
      <h2>The CityFALCON Adventure</h2>
      <p>
        Since 2014, we have been innovating solutions to the financial content problem and
        bringing the value of data to all market participants.
      </p>
      <Slider
        className={Styles['about-adventure-slider']}
        {...settings}
      >
        {
          isDesktop ? (
            data.arrayOfSlidesForDesktop.map((slide) => (
              <div
                key={slide}
              >
                <img src={slide} className={Styles['slider-image']} alt="adventure" />
              </div>
            ))
          ) : (
            data.arrayOfSlidesFor4k.map((slide) => (
              <div
                key={slide}
              >
                <img src={slide} className={Styles['slider-image']} alt="adventure" />
              </div>
            ))
          )
        }
      </Slider>
    </div>
  );
};

export default withComponentName(AboutUsAdventureSection);
